import { useMutation, useQueryClient } from '@tanstack/react-query';
import { configAdminService } from '@/services/configAdminService';
import type { SystemConfigRow } from '@/types/systemConfig';
import { queryKeys } from '@/lib/queryKeys';

export const useUpdateConfig = () => {
  const queryClient = useQueryClient();
  return useMutation<SystemConfigRow, unknown, { configKey: string; configValue: unknown }>({
    mutationFn: ({ configKey, configValue }) =>
      configAdminService.update(configKey, configValue),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.adminConfig.all });
    },
  });
};
